<template>
    <div>
        <el-dialog :visible.sync="showDetails" width="480px" :title="(alarmType==1?'传感器':(alarmType==2?'测点':'')) + '报警详情'">
            <button class="button-detail" v-if="alarmType==2 && [0, 1, 2].includes(detailsInfo.alarm_level)" type="button" @click="showDialog()" >查看图谱</button>
            <div class="body-content">
                <div class="warn-info">
                    <p class="info-title">报警信息 
                                            </p>
                    <div style="display:table">
                        <el-col :span="24">
                            <el-col :span="5"> 报警时间：</el-col>
                            <el-col :span="17" v-if="detailsInfo.create_date">{{detailsInfo.create_date}}</el-col>
                            <el-col :span="17" v-else>{{detailsInfo.update_time}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 公司名称：</el-col>
                            <el-col :span="17">{{detailsInfo.customer_name || '-'}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 站点名称：</el-col>
                            <el-col :span="17">{{detailsInfo.site_name || '-'}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 设备名称：</el-col>
                            <el-col :span="17">{{detailsInfo.equipment_name}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 测点名称：</el-col>
                            <el-col :span="17">{{detailsInfo.point_name || '-'}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 传感器类型：</el-col>
                            <el-col :span="17">{{sensorTypeDic[detailsInfo.sensor_type]}}</el-col>
                        </el-col>
                        <el-col :span="24" v-if="alarmType==1">
                            <el-col :span="5"> 报警状态：</el-col>
                            <el-col :span="17">{{sensorAlarmLevel[detailsInfo.alarm_level]}}</el-col>
                        </el-col>
                        <el-col :span="24"  v-if="alarmType==2">
                            <el-col :span="5"> 报警状态：</el-col>
                            <el-col :span="17">{{alarmLevel[detailsInfo.alarm_level]}}</el-col>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5"> 状态描述：</el-col>
                            <el-col :span="17">{{alarmType==1?sensorAlarmDescribeDict[detailsInfo.alarm_describe]:(alarmType==2?alarmDescribeDict[detailsInfo.alarm_describe]:'-')}}</el-col>
                        </el-col>
                    </div>
                    <div class="form-class">
                    <p class="info-title">报警处理</p>
                    <el-form :model="handleForm" label-position="left">
                        <!-- 处理结果：作为一级 el-form-item -->
                        <el-form-item label="处理结果：" label-width="98px">
                        <el-radio-group v-model="handleForm.is_processed" v-if="detailsInfo.processed_num != 2">
                            <el-radio :label="true">手动处理</el-radio>
                            <el-radio :label="false">未处理</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="detailsInfo.processed_num" v-if="detailsInfo.processed_num == 2">
                            <el-radio :label="2" :disabled="true">自动处理</el-radio>
                        </el-radio-group>
                        </el-form-item>

                        <!-- 处理方式：作为独立的一级 el-form-item（移出嵌套） -->
                        <el-form-item label="处理方式：" label-width="98px" v-if="handleForm.is_processed && detailsInfo.alarm_level<=2">
                        <el-checkbox v-model="enable_alarm_restraint" style="color: #ffffff">报警抑制</el-checkbox>                   
                        <el-input
                            v-model="alarm_restraint_info.push_no_alarm_minutes"
                            type="number"
                            :min="1"
                            :max="65535"
                            style="width: 180px"
                            placeholder="请输入"
                            v-if="enable_alarm_restraint"
                            class="input-with-select"
                        >
                            <template #append>
                            <el-select
                                v-model="selectTime"
                                placeholder="分钟"
                                style="width: 75px"
                            >
                                <el-option label="分钟" value="min" />
                            </el-select>
                            </template>
                        </el-input>
                        </el-form-item>

                        <!-- 处理意见：作为一级 el-form-item -->
                        <el-form-item label="处理意见：" label-width="98px">
                        <el-input type="textarea" placeholder="请输入内容" v-model="handleForm.processed_remarks"></el-input>
                        </el-form-item>
                    </el-form>
                    </div>
                </div>
            </div>
             <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleAlarm">确 定</el-button>
                <el-button @click="showDetails = false">取 消</el-button>
            </span>
        </el-dialog>
        <div v-if="showChartDetails">
            <chartDetails :visible.sync="showChartDetails" :dataDetails="detailsInfos" :isWsUpdate="false">
            </chartDetails>
        </div>
        <div  v-if="showjx" >
            <jx  :visible.sync="showjx" :dataDetails="detailsInfo"></jx>
        </div>
        <div v-if="showNearestMotorSeq">
           <NearestMotorSeq :visible.sync="showNearestMotorSeq" :dataDetails="detailsInfo"></NearestMotorSeq>
        </div>
    </div>
</template>
<script>
import * as warning from '@/data/warning.js'
import * as file from '@/data/file.js'
import * as device from '@/data/device.js'
import {alarmDescribeDict, sensorAlarmDescribeDict, sensorTypeDic, alarmLevel, sensorAlarmLevel} from "@/util/sensorType.js"
export default {
    name: '',
    components: {
        chartDetails: resolve => { require(['../site/chartDetails.vue'], resolve) },
        jx: resolve => {require(['../site/jx.vue'], resolve)},
        NearestMotorSeq: resolve => {require(['../site/components/NearestMotorSeq/NearestMotorSeqDialog.vue'], resolve)}
    },
   data() {
      return {
        showClo:false,
        handleForm:{
            is_processed:'',
            processed_remarks:'',
          },
          alarmLevel: alarmLevel,
          sensorAlarmDescribeDict,
          alarmDescribeDict,
          sensorTypeDic,
          //0-未知类型，1-传感器、2-测点
          alarmType: 0,
          sensorAlarmLevel,
          showChartDetails: false,
          enable_alarm_restraint: false,
          alarm_restraint_info: {
              alarm_duration: 60,
              max_alarm_nums: 0,
              push_no_alarm_minutes: ''
          },
          selectTime: "min",
          pointParams: {},
          detailsInfos: [],
          showjx: false,
          showNearestMotorSeq: false
      }
   },
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        detailsInfo: {
            type: Object,
            default: ()=>({})
        }
    },
   computed:{
        showDetails:{
               get(){
                   return this.visible;
               },
               set(val){
                   this.$emit('update:visible',val)
               }
           }
       },
    created() {
   },
    mounted() {
        this.$nextTick(() => {
            if (this.detailsInfo) {
                this.handleForm.is_processed = this.detailsInfo.is_processed;
                this.handleForm.processed_remarks = this.detailsInfo.processed_remarks;
                this.alarmType = this.detailsInfo.alarm_type
               /* if(this.detailsInfo.sensor_data_id && this.detailsInfo.sensor_data_id != 'None'){
                  this.alarmType = 2
                }else{
                  this.alarmType = 1
                } */
            }
        }),
        this.getPointInfo()
   },
    methods: {
        getPointInfo(){
            file.pointDetails({equipment_id: this.detailsInfo.equipment_id, point_id: this.detailsInfo.point_id}).then(res => {
                const point_info = res.data
                this.pointParams = {
                    measure_name: res.data.measure_name,
                    measure_type: res.data.measure_type,
                    remarks: res.data.remarks,
                    sensor_number: res.data.sensor_number,
                    enable_block_alarm: res.data.enable_block_alarm,
                    enable_alarm_restraint: res.data.enable_alarm_restraint,
                    enable_long_trend_alarm:  res.data.enable_long_trend_alarm,
                    enable_short_trend_alarm: res.data.enable_short_trend_alarm,
                    alarm_restraint_info: JSON.parse(JSON.stringify(res.data.alarm_restraint_info)),
                    restraint_deadline: res.data.restraint_deadline,
                    restraint_flag: res.data.restraint_flag
                };
                if (this.detailsInfo.is_processed) {
                    this.enable_alarm_restraint = this.pointParams.enable_alarm_restraint
                    this.alarm_restraint_info = JSON.parse(JSON.stringify(this.pointParams.alarm_restraint_info));
                }
            })
        },
        handleAlarm(row) {
            warning.handleAlarm({data:this.handleForm,alarm_id:this.detailsInfo.alarm_id}).then(res => {
                this.$message({ type: 'success', message: '修改成功' });
                this.$emit("clickNode");
                this.$emit("refreshTree");//更新树的未处理数
                this.showDetails = false
            })
            let paramBody = {}
            if (this.enable_alarm_restraint) {
                const old_push_no_alarm_minutes = Number(this.pointParams.alarm_restraint_info.push_no_alarm_minutes)
                const new_push_no_alarm_minutes = Number(this.alarm_restraint_info.push_no_alarm_minutes)
                const push_no_alarm_minutes = new_push_no_alarm_minutes > old_push_no_alarm_minutes? new_push_no_alarm_minutes : old_push_no_alarm_minutes
                if (this.pointParams.enable_alarm_restraint) {
                    paramBody = {
                        enable_block_alarm: this.pointParams.enable_block_alarm,
                        enable_alarm_restraint: this.pointParams.enable_alarm_restraint,
                        alarm_restraint_info: {
                            alarm_duration: this.pointParams.alarm_restraint_info.alarm_duration,
                            max_alarm_nums: this.pointParams.alarm_restraint_info.max_alarm_nums,
                            push_no_alarm_minutes: push_no_alarm_minutes
                        },
                        // alarm_restraint_info: this.pointParams.alarm_restraint_info,
                        restraint_flag: true,
                        restraint_deadline_minutes: Number(push_no_alarm_minutes)
                    }
                }else {
                    paramBody = {
                        enable_block_alarm: this.pointParams.enable_block_alarm,
                        enable_alarm_restraint: true,
                        alarm_restraint_info: {
                            alarm_duration: 60,
                            max_alarm_nums: 2,
                            push_no_alarm_minutes: push_no_alarm_minutes
                        },
                        restraint_flag: true,
                        restraint_deadline_minutes: Number(push_no_alarm_minutes)
                    }
                }
                device.pointRestraint({point_id: this.detailsInfo.point_id, body: paramBody}).then((res) => {
                    this.$message({ type: 'success', message: '已刷新报警抑制' });
                }).catch(err => {
                    console.log(err)
                })
            }
        },
        showDialog(row){
            let outLoading = this.$loading({
                target: '.el-dialog',          
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });   
            try {
                if (this.detailsInfo.sensor_type === 'MECH') {
                    this.showjx = true;
                    outLoading.close();
                    return;
                }
                if (this.detailsInfo.sensor_type === 'MECHSEP') {
                    this.showNearestMotorSeq = true;
                    outLoading.close();
                    return;
                }
                if ([3,4,5,6].includes(this.detailsInfo.alarm_level)) {
                    this.trendSelectData = [{point_id: this.detailsInfo.point_id, sensor_type: this.detailsInfo.sensor_type, point_name: this.detailsInfo.point_name, site_id: this.detailsInfo.site_id}]
                    warning.getTrendAlarmDataList({trend_alarm_id: this.detailsInfo.trend_alarm_detail_id}).then(val => {
                        this.trend_char_data = val.data
                        this.showTrendDetails = true;
                        outLoading.close();
                    }).catch(err => {
                    })

                } else {
                    let equipment_id = this.detailsInfo.equipment_id
                    let start_date = this.detailsInfo.create_date? this.detailsInfo.create_date: this.detailsInfo.update_time
                    let max_query_num = 100
                    const params = {
                        equipment_id: equipment_id,
                        body: {
                            start_date: start_date,
                            max_query_num: max_query_num
                        }
                    }
                    device.findNearData(params).then(res => {
                        const { data = [] } = res; // 解构并默认空数组，避免报错
                        
                        // 空数据提前处理
                        if (data.length === 0) {
                            this.$message.warning("历史数据已被清理");
                            outLoading.close();
                            return;
                        }

                        // 1. 提取当前传感器数据（最优先）
                        const currentSensorData = data.filter(item => 
                            item.sensor_data_id === this.detailsInfo.sensor_data_id
                        );

                        // 2. 分离其他数据（排除当前传感器）
                        const otherData = data.filter(item => 
                            item.sensor_data_id !== this.detailsInfo.sensor_data_id
                        );

                        // 定义局放类型常量
                        const pdTypes = ["HFCT", "UHF", "AE", "TEV", "PC"];
                        const currentType = this.detailsInfo.sensor_type; // 当前传感器类型

                        const [sameType, pdData, remainingData] = otherData.reduce((acc, item) => {
                            const [same, pd, remaining] = acc;
                            
                            if (item.sensor_type === currentType) {
                            // 3.1 同类型（非当前传感器）
                            same.push(item);
                            } else if (pdTypes.includes(item.sensor_type)) {
                            // 3.2 局放类型（非当前类型）
                            pd.push(item);
                            } else {
                            // 3.3 剩余其他类型
                            remaining.push(item);
                            }
                            
                            return acc;
                        }, [[], [], []]); // 初始值：[同类型, 局放类型, 剩余类型]

                        // 4. 按优先级合并：自己 → 同类型 → 局放 → 剩余
                        this.detailsInfos = [].concat(
                            currentSensorData,
                            sameType,
                            pdData,
                            remainingData
                        );

                        this.showChartDetails = true;
                        outLoading.close();
                    });
                }
            } catch(err) {
                outLoading.close();
                console.log('请求报警数据出错：', err)
            }
            // this.showChartDetails = true;
        },
   },
}
</script>
<style lang="less" scoped>
/deep/.el-dialog{

    background: #2C2E30;
    .el-dialog__header{
        // padding:8px 5px;
        // border-bottom: solid 3px #ccc;
        .el-dialog__title{
            color:#fff;
        }
    }

    .el-dialog__headerbtn{
        top:8px;
    }
    .el-dialog__body{
        padding:0;
        color:#fff;
        .form-class{
            .el-form-item__label{
                text-align: right;
            }
            .el-form-item__label,.el-form-item__content{
                line-height: 28px;color:#fff;
            }
            .el-radio{
                color:#fff;
            }
        }
        .warn-info{
            padding:0 30px;
            .el-col-5{
                text-align: right;
            }
            .el-col-5,.el-col-17{
                height:28px;line-height: 28px;
            }
            .info-title{
                height:32px;line-height: 32px;;
            }
        }
    }
    .el-dialog__footer{
        text-align: center;padding:10px;
        .el-button{
            padding:5px 15px;background:transparent;color:#fff;
        }
    }
    .button-detail{
        padding: 3px;
        // // margin-left:50px;
        margin-right: 20px;
        margin-top: 5px;
        border: 0;
        background-color: #0b6cdaff;
        color: #FFF;
        float: right
    }
    .button-detail:hover{
        cursor: pointer;
        background-color: #2f8efaff;
    }

}
/deep/.el-input__inner {
    height: 25px !important;
    color: #606266 !important;
    border: none !important;
}
/deep/.el-input__icon {
    line-height: 0px !important
}
</style>



// WEBPACK FOOTER //
// src/view/warning/details.vue